import { render, staticRenderFns } from "./FranchiseManualHistoryCard.vue?vue&type=template&id=654ade08&scoped=true"
import script from "./FranchiseManualHistoryCard.vue?vue&type=script&lang=js"
export * from "./FranchiseManualHistoryCard.vue?vue&type=script&lang=js"
import style0 from "./FranchiseManualHistoryCard.vue?vue&type=style&index=0&id=654ade08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654ade08",
  null
  
)

export default component.exports